<template>
    <div class="product-list">
        <div v-for="(item,index) in proFunction" :index="index" class="product-info" :id="item.id">
            <img :src="item.url" :_src="item.url1" alt="">
            <div class="product-mes">
                <h1 class="common-font">{{item.title}}</h1>
                <div
                    v-for="mes in item.functionList"
                    class="product-pro"
                >
                    <h2>{{mes.name}}</h2>
                    <div v-for="cont in mes.detail" class="mesDetail">
                        <i></i>
                        <p>{{cont}}</p>
                    </div>
                </div>
                <a :href="item.docs" :download="item.title" v-if="item.docs" class="down-docs">Download PDF <i></i></a>
                <a :href="item.linkTo" v-if="item.linkTo" class="linkTo">More +</a>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "product-list",
        props: ['proFunction']
    }
</script>

<style lang="less">

    .product-list {
        display: flex;
        /*justify-content: space-around;*/
        flex-wrap: wrap;
        margin-left: -40px;
        padding-bottom: 32px;
        .common-font{
            font-family: 'Gotham-Medium',"Avenir Next", 'Helvetica Neue', 'PingFang SC';
            font-weight: 500;
        }
        .product-info {
            display: flex;
            margin-bottom: 64px;
            margin-left: 40px;
            img {
                width: 100px;
                height: 100px;
                margin-right: 40px;
            }
            .product-mes {
                color: #252525;
                width: 380px;
                h1 {
                    font-size: 28px;
                    line-height: 36px;
                }

                .product-pro {
                    h2 {
                        font-size: 18px;
                        line-height: 26px;
                        margin: 14px 0 8px;
                    }
                    .mesDetail {
                        /*text-align: left;*/
                        /*float: left;*/
                    }
                    p {
                        display: inline-block;
                        font-size: 14px;
                        color: #5D5D5D;
                        line-height: 22px;
                        padding: 5px 0;
                        width: 340px;

                    }
                    i {
                        display: inline-block;
                        width: 5px;
                        height: 5px;
                        border-radius: 50%;
                        background: #5D5D5D;
                        vertical-align: top;
                        margin-right: 20px;
                        margin-left: 10px;
                        margin-top: 15px;
                    }
                }
                .down-docs {
                    text-decoration: underline;
                    display: block;
                    font-size: 14px;
                    color: #252525;
                    line-height: 22px;
                    margin-top: 22px;
                    i {
                        display: inline-block;
                        background: url("/static/image/product/download@1x.png") no-repeat center;
                        width: 16px;
                        height: 16px;
                        margin-left: 10px;
                        vertical-align: middle;
                        margin-bottom: 5px;
                    }
                }
                .linkTo {
                    display: block;
                    font-size: 18px;
                    color: #252525;
                    line-height: 26px;
                    margin-top: 22px;
                    text-decoration: underline;
                }
            }
        }
    }

    @media screen and (max-width: 1680px) {
        @autoWidth:1256px;
        .product-list {
            /*<!--min-width: @autoWidth;-->*/
            justify-content: space-between;
            margin-left: 0;
            .product-info {
                margin-left: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/common/productList.vue